import { buildClassCatalogPath } from "@/utils/catalogSlug";
import type { AdminClass } from "../types/class.types";

/**
 * Public catalog preview URL for admin globe action.
 * Canonical shape: /classes/{levelname}/{class-slug}?level1Id={parent}
 * level1Id disambiguates duplicate level-2 names under different parents.
 */
export function buildPublicClassPreviewUrl(record: AdminClass): string | null {
  const categorySlug = record.categorySlug?.trim();
  const courseSlug = record.slug?.trim();

  if (!categorySlug || !courseSlug) {
    return null;
  }

  const origin = `${window.location.origin}${window.location.pathname}`;
  const path = buildClassCatalogPath(categorySlug, courseSlug);
  const level1Id = record.levels?.level1Id?.trim();

  if (level1Id) {
    return `${origin}#${path}?level1Id=${encodeURIComponent(level1Id)}`;
  }

  return `${origin}#${path}`;
}
